export const buttonSX = {
  boxShadow: "unset",
  borderRadius: "8px",
  justifyContent: "center",
  alignItems: "center",
};

export const buttonLoaderStyles = {
  color: "#000",
  position: "absolute",
  left: "50%",
  top: "50%",
  marginLeft: "-12px",
  marginTop: "-12px",
};
